<template>
  <div>
    <template v-if="orderInfo">
      <OrderForm @submit="onSubmit" :is-executor="isExecutor" :order-info="orderInfo" :customer-inn="$store.getters.companyInn" :is-number-unique-error="isNumberUniqueError">
        <template slot="title"> Редактирование заказа</template>
      </OrderForm>

      <v-dialog v-model="saveFailedDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 error--text"> Ошибка при обработке запроса на сервере</v-card-title>
          <v-card-text> {{ saveFailedDialogText }}</v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" text @click="saveFailedDialog = false">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <h3>Подождите, идет загрузка заказа</h3>
    </template>
  </div>
</template>

<script>
import OrderService from "@/services/order.service";
import OrderForm from "@/components/main/order/OrderForm";

import _ from "underscore";
import mappers from "@/helpers/mappers";
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
} from "@/store/modules/layout/actions";
import {MOMENT_API_DATE_FORMAT} from "@/settings";

export default {
  name: "EditOrder",
  components: {
    OrderForm,
  },
  data() {
    return {
      orderInfo: null,
      saveFailedDialogText: '',
      saveFailedDialog: false,
      isNumberUniqueError: false,
    };
  },
  computed: {
    isExecutor() {
      return (
          this.orderInfo &&
          this.orderInfo.executorInn === this.$store.getters.companyInn
      );
    },
  },
  methods: {
    loadOrder() {
      this.$store.dispatch(LAYOUT_LOADING_START);
      const id = +this.$route.params.id;
      OrderService.getInfo(id)
          .then(response => {
            this.orderInfo = mappers.mapOrderInfo(response.data)
          })
          .catch(() => {
            this.$router.go(-1);
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
    onSubmit(form) {
      const data = {
        ExecutorEditStrategy: form.executorEditStrategy,
        ShipmentDeliveryDateStrategy: form.shipmentDeliveryDateStrategy,
        ExecutorCreateInvoiceStrategy: form.executorCreateInvoiceStrategy,
        OrderShipmentDateMethodStrategy: form.orderShipmentDateMethodStrategy,
        OrderProductNameDefineMethodStrategy: form.orderProductNameDefineMethodStrategy,
        OrderContractDefineMethodStrategy: form.orderContractDefineMethodStrategy,
        OrderItemQuantityLimitStrategy: form.orderItemQuantityLimitStrategy,

        ProviderInn: form.executorInn,
        ProviderName: form.executorName,

        OrderNumber: form.number,
        OrderDate: form.date.format(MOMENT_API_DATE_FORMAT),

        ContractNumber: form.contractNumber,
        ContractDate: form.contractDate.format(MOMENT_API_DATE_FORMAT),

        OrderExpire: form.expireDate.format(MOMENT_API_DATE_FORMAT),

        DeliveryAddress: form.deliveryAddress,
        BranchId: form.branch,
        CustomerSystemId: typeof(form.customerSystemId) === 'string' && form.customerSystemId ? form.customerSystemId : null,
        CustomerShipmentId: typeof(form.customerShipmentId) === 'string' && form.customerShipmentId ? form.customerShipmentId : null,

        Items: _.map(form.items, (i) => {
          return {
            Id: i.id,
            Product: i.product,
            Measurement: i.measurement,
            Quantity: +i.quantity,
            Price: +i.price,
            NdsRate: +i.ndsRate,
            CustomerCode: i.customerCode,
            CatalogCode: i.catalog ? i.catalog.classCode : null,
            CatalogName: i.catalog ? i.catalog.classNameRu : null,
            CustomerSystemItemId: typeof(i.customerSystemId) === 'string' && i.customerSystemId ? i.customerSystemId : null,
            CustomerShipmentItemId: typeof(i.customerShipmentItemId) === 'string' && i.customerShipmentItemId ? i.customerShipmentItemId : null,
            ProductCode: typeof(i.productCode) === 'string' ? i.productCode : null,
          };
        }),
      };
      this.$store.dispatch(LAYOUT_LOADING_START);

      this.isNumberUniqueError = false
      OrderService.edit(this.orderInfo.id, data)
          .then(() => {
            this.$router.push({
              name: "order-page",
              params: {id: this.orderInfo.id},
            });
          })
          .catch(exception => {
            if (exception.response && exception.response.data && exception.response.data.Message && exception.response.data.Message.Message) {
              this.saveFailedDialogText = exception.response.data.Message.Message
              this.saveFailedDialog = true

              this.isNumberUniqueError = exception.response.data.Message.Code === 100
            }
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
  },
  created() {
    this.loadOrder();
  },
  watch: {
    "$route.params.id"() {
      this.loadOrder();
    },
  },
};
</script>